import { TESTING_MARKETS } from '../../helpers/markets';

// Helper function to check if current date is after 2024-01-01 12:00 am PST
// Will clean up after 1/1, Jira ticket: https://opendoor.atlassian.net/browse/PRTNR-3121
const isAfter2024 = () => {
  const currentDate = new Date();
  const cutoffDate = new Date('2024-01-01T08:00:00.000Z'); // 12:00 am PST is 8:00 am UTC
  return currentDate > cutoffDate;
};

export const REFERRAL_LIST_ITEMS = [
  'Ideal for when you can’t (or don’t want to) represent a client',
  'Share the homeowner’s contact information with Opendoor',
  'That’s all there is to it — we work with the homeowner to complete the sale',
];

export const REPRESENTATION_LIST_ITEMS = [
  'Ideal for clients that need more guidance and support ',
  'You’ll represent your client throughout the entire process',
  'You’ll work directly with Opendoor   and expect to have a representation agreement with your client',
];

export const REFERRAL_HEADER = 'Refer to Opendoor';
export const REPRESENTATION_HEADER = 'Represent your client';

export const REFERRAL_SUBHEADER = (market: string) => {
  return `Eligible for ${
    TESTING_MARKETS.includes(market) && !isAfter2024 ? 3 : 1
  }% referral commission`;
};

export const REPRESENTATION_SUBHEADER = (market: string) => {
  return `Eligible for ${
    TESTING_MARKETS.includes(market) && !isAfter2024 ? 3 : 1
  }% commission + seller commission`;
};
